import { Injectable, NotFoundException } from '@nestjs/common';
import { EntityManager } from '@mikro-orm/core';
import { File } from '../entities/file.entity';
import { User } from '../../user/entities/user.entity';

@Injectable()
export class FileService {
  constructor(
    private readonly em: EntityManager
  ) {}

  async create(body: { url: string, user: User, module: string, module_id: number | null, mime_type: string }): Promise<File> {
    const file = new File();
    file.url = body.url;
    file.user = body.user;
    file.module = body.module;
    file.module_id = body.module_id;
    file.mime_type = body.mime_type;
    await this.em.persistAndFlush(file);
    return file;
  }

  async findAll(): Promise<File[]> {
    return this.em.find(File, { deleted_at: null }, { populate: ['user'] });
  }

  async find(condition: any): Promise<File[]> {
    return this.em.find(File, condition, { populate: ['user'] });
  }

  async findOne(id: number): Promise<File> {
    const file = await this.em.findOne(File, { id, deleted_at: null }, { populate: ['user'] });
    if (!file) {
      throw new NotFoundException(`File with ID "${id}" not found`);
    }
    return file;
  }

  async remove(id: number): Promise<void> {
    const file = await this.findOne(id);
    file.deleted_at = new Date();
    await this.em.persistAndFlush(file);
  }
}
